import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Focuses this field with the keyboard open. Native apps only show the
// keyboard for a focus the user started, so the app is asked to allow the
// next one first. Without native support this doesn't load and the field's
// autofocus attribute focuses it as usual.
export default class extends BridgeComponent {
  static component = "keyboard-focus"

  connect() {
    super.connect()

    this.send("focus", {}, () => {
      // Turbo has already focused an autofocus field, and focusing it again
      // isn't a new focus.
      this.element.blur()
      this.element.focus()
    })
  }
}
